import { createContext, useContext, useEffect, useState } from "react";
import { api, TOKEN_KEY } from "@/pos/lib/api";
import { useAuth as useAlfazAuth } from "@/lib/auth";

const AuthCtx = createContext(null);

export function AuthProvider({ children }) {
  const { token, logout: alfazLogout } = useAlfazAuth();
  const [user, setUser] = useState(null);

  useEffect(() => {
    if (!token) { setUser(false); return; }
    api.get("/me").then((r) => setUser(r.data)).catch(() => setUser(false));
    const onExpired = () => setUser(false);
    window.addEventListener("auth-expired", onExpired);
    return () => window.removeEventListener("auth-expired", onExpired);
  }, [token]);

  const logout = () => { localStorage.removeItem(TOKEN_KEY); alfazLogout(); setUser(false); };

  return <AuthCtx.Provider value={{ user, logout, isOwner: user && user.role === "owner" }}>{children}</AuthCtx.Provider>;
}

export const useAuth = () => useContext(AuthCtx);
